import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Auth } from '@angular/fire/auth';

@Component({
  selector: 'soph-modal-error-general',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-error-general.component.html',
  styleUrl: './modal-error-general.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalErrorGeneralComponent {
  private readonly dialogRef = inject(MatDialogRef<ModalErrorGeneralComponent>);
  private readonly router = inject(Router);

  protected data?: {
    message?: string;
    callbackUrl?: string;
  } = inject(MAT_DIALOG_DATA);

  redirectTo() {
    this.dialogRef.close();
    this.router.navigate([this.data?.callbackUrl || '/login'], { replaceUrl: true });
  }
}
